export default "__VITE_ASSET__Lsc25_qz__"